export default __webpack_public_path__ + "static/operational-img-3-35b78fb30d91ad2e4064d702da46c6e4.png";